import { Icon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import StudioIcon from 'assets/icons/StudioIcon';
import { locations } from 'services/routes/locations';
import {
  StyledBox,
  StyledLink,
  StyledSubtitleWrapper,
  StyledTitle,
} from './styled';
import useTrackClick from './useTrackClick';

const BrowseRoyaltyFreeTile = () => {
  const { t } = useTranslation();
  const { pathname } = locations.general.songList;

  const tileTitle = t('discoveryPage:headerTiles:titles:browseRoyaltyFree');
  const handleTrackClick = useTrackClick(tileTitle);

  return (
    <StyledLink to={{ pathname }} onClick={handleTrackClick}>
      <StyledBox>
        <Icon color="secondary">
          <StudioIcon />
        </Icon>
        <StyledTitle>{tileTitle}</StyledTitle>
        <StyledSubtitleWrapper>
          <Typography>
            {t('discoveryPage:headerTiles:subtitle:browseTemplates')}
          </Typography>
          <KeyboardArrowRightIcon className="arrow-right" />
        </StyledSubtitleWrapper>
      </StyledBox>
    </StyledLink>
  );
};

export default BrowseRoyaltyFreeTile;
